import { CRMApiEntityType, UserRole } from '../@types/api';
import CRMCommissionTab from '../components/organisms/crm/CRMCommissionTab';
import CRMDetailsTab from '../components/organisms/crm/CRMDetailsTab';
import CRMNotesTab from '../components/organisms/crm/CRMNotesTab';
import CRMTasksTab from '../components/organisms/crm/CRMTasksTab';
import { USER_ROLES } from '../constants/keycloak';

import type { JSX } from 'react';

export type CRMTabConfig = {
  label: string;
  Component: JSX.Element;
  visibleFor?: UserRole[];
}[];

export const CUSTOMER_TAB_CONFIG: CRMTabConfig = [
  {
    label: 'Details',
    Component: <CRMDetailsTab userType='customer' />,
  },
  {
    label: 'Notes',
    Component: <CRMNotesTab userType='customer' />,
  },
  {
    label: 'Tasks',
    Component: <CRMTasksTab userType='customer' />,
  },
];

export const PARTNER_TAB_CONFIG: CRMTabConfig = [
  {
    label: 'Details',
    Component: <CRMDetailsTab userType='partner' />,
  },
  {
    label: 'Notes',
    Component: <CRMNotesTab userType='partner' />,
  },
  {
    label: 'Tasks',
    Component: <CRMTasksTab userType='partner' />,
  },
  {
    label: 'Commission',
    Component: <CRMCommissionTab />,
    visibleFor: ['Agent', 'Affiliate'],
  },
];

export const PARTNER_ROLE_TYPES = [
  USER_ROLES.ADMIN,
  USER_ROLES.MANAGER,
  USER_ROLES.AGENT,
  USER_ROLES.AFFILIATE,
  USER_ROLES.TECH_SUPPORT,
  USER_ROLES.TRADER,
];

export const PATH_TO_USER_TYPE_MAP: Record<string, CRMApiEntityType> = {
  players: 'customer',
  partners: 'partner',
};

export const USER_TYPE_TO_CRM_API_ENTITY_MAP = {
  customer: 'customer',
  partner: 'agent',
};
